export default __webpack_public_path__ + "static/media/tale_of_four.49f8471d.png";